export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'bh_access_token',
  REFRESH_TOKEN: 'bh_refresh_token',
  USER: 'bh_user',
  THEME_MODE: 'bh_theme_mode',
  SIDEBAR_COLLAPSED: 'bh_sidebar_collapsed',
  LOCALE: 'bh_locale',
};
